import * as React from "react";
import { UitkHeading } from "uitk-react-text";
import { HotelRecentReviewsFlexModuleResult } from "typings/microserviceModels/hotel-recent-reviews-flex-module";

const ThumbnailImageLeftCardModuleTitle = (props: { model: HotelRecentReviewsFlexModuleResult }) => {
  return (
    <UitkHeading level={2} size={600}>
      {props.model.title}
    </UitkHeading>
  );
};

export default ThumbnailImageLeftCardModuleTitle;
